import { useState, useEffect, useCallback } from "react";
import { fetchPublishedPage } from "@/lib/sacred-pages/sacred-pages-api";
import { getDefaultSacredPage } from "@/lib/sacred-pages/defaults";
import { pageAssetUrl } from "@/lib/sacred-pages/sacred-pages-api";

function mergePage(slug, published, assetUrl) {
  const fallback = getDefaultSacredPage(slug);
  if (!published) {
    return {
      ...fallback,
      _source: "static",
      metadata: {
        ...fallback.metadata,
        hero_image: assetUrl || fallback.metadata?.hero_image,
      },
    };
  }
  return {
    ...fallback,
    ...published,
    title: published.title || fallback.title,
    sections: published.sections?.length ? published.sections : fallback.sections,
    metadata: {
      ...fallback.metadata,
      ...published.metadata,
      hero_image: assetUrl || published.metadata?.hero_image || fallback.metadata?.hero_image,
    },
    _source: "published",
  };
}

export function useSacredPage(slug) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!slug) return;
    setLoading(true);
    try {
      const data = await fetchPublishedPage(slug);
      const asset = data.asset_url ? `${pageAssetUrl(slug)}` : null;
      setPage(mergePage(slug, data.page, asset));
    } catch {
      setPage(mergePage(slug, null, null));
    }
    setLoading(false);
  }, [slug]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { page, loading, reload };
}
